import { Theme } from "@mui/material/styles"

interface Styles {
  [key: string]: any
}

export const styles = (theme: Theme): Styles => ({
  container: {
    display: "flex",
    flexDirection: "column",
    // Fill DashboardLayout after it became a flex column shell.
    flex: 1,
    minHeight: 0,
    height: "100%",
    padding: theme.spacing.spacing6,
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing.spacing12_5,
    flexShrink: 0,
  },
  logo: {
    height: "32px",
    width: "auto",
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    justifyContent: "center",
    alignItems: "flex-start",
  },
  bodyContentLTR: {
    paddingLeft: theme.spacing.spacing6,
  },
  bodyContentRTL: {
    paddingRight: theme.spacing.spacing6,
  },
  title: {
    fontSize: theme.typography.size.lg,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: "28px",
    marginBottom: theme.spacing.spacing7,
  },
  description: {
    fontSize: theme.typography.size.sm,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: "22px",
    whiteSpace: "pre-line",
    marginBottom: theme.spacing.spacing12_5,
  },
  tenantButtons: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.spacing4,
  },
  startButton: {
    minWidth: "240px",
    height: theme.spacing.spacing28,
    fontSize: theme.typography.size.md,
  },
})
